<template>
    <flex-element :element-type="elementType" class="f-inline-flex f-self-start" class-default-inline="f-border-1 f-px-0.5 f-py-0.25 f-bg-white">
        <input
            :id="inputId || inputNameNew"
            class="f-w-1/1 input"
            :name="inputNameNew"
            :type="renderInputType"
            :placeholder="placeholderNew"
            :pattern="renderPattern ? renderPattern : false"
            :required="renderRequired"
            :value="inputValueNew"
            :aria-label="ariaLabelNew"
            :aria-labelledby="ariaLabelledByNew"
            style="background-color:inherit;"
            @input="onInput"
            @keyup="onKeyup"
            @invalid="onInvalidInput"
        >
    </flex-element>
</template>

<script>
import { mapState } from 'vuex';

import baseAtom from '@/mixins/base-atom/base-atom-smart';
import { AInput } from '@/data/data-models';
import { getCookie } from '@/utils/cookie';

const publicMode = process.env.VUE_APP_ENV === 'public';

export default {
    name: 'a-input',
    mixins: [baseAtom],

    props: {
        displayName: {
            type: String,
            default: 'Text Input',
        },

        inputId: {
            type: String,
            default: '',
        },

        inputName: {
            type: String,
            default: '',
        },

        inputType: {
            type: String,
            default: '',
        },

        inputTypeDefault: {
            type: String,
            default: 'text',
        },

        inputValue: {
            type: String,
            default: '',
        },

        placeholder: {
            type: String,
            default: '',
        },

        placeholderDefault: {
            type: String,
            default: '',
        },

        pattern: {
            type: String,
            default: '',
        },

        patternDefault: {
            type: String,
            default: '',
        },

        required: {
            type: Boolean,
            default: false,
        },

        requiredDefault: {
            type: Boolean,
            default: false,
        },

        validationMessage: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            cssDisplay: 'inline-flex',
            inputNameNew: '',
            inputTypeNew: '',
            inputValueNew: '',
            patternNew: '',
            placeholderNew: '',
            requiredNew: '',
            validationMessageNew: '',
        };
    },

    computed: {
        ...mapState({
            previewMode: state => state.previewMode,
        }),

        editingMode() {
            return publicMode || !this.previewMode;
        },

        isHiddenInput() {
            return this.inputTypeNew === 'hidden';
        },

        renderInputType() {
            let type = this.inputTypeNew || this.inputTypeDefault;

            if (this.editingMode && type === 'hidden') {
                type = 'text';
            }

            return type;
        },

        renderPattern() {
            return this.patternNew || this.patternDefault;
        },

        renderPlaceholder() {
            return this.placeholderNew || this.placeholderDefault;
        },

        renderRequired() {
            return this.requiredNew || this.requiredDefault;
        },

        updatedElement() {
            return new AInput({
                ...this.updatedBaseElement,
                inputName: this.inputNameNew,
                inputType: this.inputTypeNew,
                inputValue: this.inputValueNew,
                pattern: this.patternNew,
                placeholder: this.placeholderNew,
                required: this.requiredNew,
                validationMessage: this.validationMessageNew,
            });
        },
    },

    beforeMount() {
        if (this.getElementData('load-cookie')) {
            this.inputValueNew = decodeURIComponent(getCookie(this.inputName) || '');
        }
    },

    methods: {
        setFieldValues() {
            this.inputNameNew = this.inputName;
            this.inputTypeNew = this.inputType;
            this.inputValueNew = this.inputValue;
            this.patternNew = this.pattern;
            this.placeholderNew = this.placeholder;
            this.requiredNew = this.required;
            this.validationMessageNew = this.validationMessage;
        },

        onInput(e) {
            this.setChangedData(true);
            e.target.setCustomValidity('');
        },

        onKeyup(e) {
            this.$emit('keyup', e);
        },

        onInvalidInput(e) {
            e.target.setCustomValidity(this.validationMessageNew);
        },
    },
};
</script>

<style lang="scss" scoped>
.input {
    font-size: 1em;
}
</style>
